
export default {
    name: 'SearchHistoryList',
    props: {
        feature: {
            type: String,
            default: undefined
        },
        store: {
            type: String,
            default: 'files'
        }
    },
    data () {
        return {
            form: new this.$vForm({})
        }
    },
    computed: {
        histories () {
            return this.$store.state[this.store].history
        }
    },
    mounted () {
        if (this.histories && 'search' in this.histories) {
            return
        }
        this.form.update({ feature: this.feature })
        this.form.get(this.localePath('/v1/files/history'))
            .then((res) => {
                this.$store.commit(this.store + '/setHistory', res.data)
            })
            .catch((e) => {
                this.$store.commit(this.store + '/setHistory', null)
            })
    }
}
